mutation InviteGuests($eventId: ID!, $emails: String!) {
  inviteGuests(input: { eventId: $eventId, emails: $emails }) {
    result {
      invited {
        id
        firstName
        lastName
        email
      }
      alreadyOnList
      notFound
      ambiguous
      invalid
    }
  }
}
